import React, {PureComponent} from "react"
import {InjectIntl, injectIntl, FormattedDate, FormattedMessage} from "@irati/utils/lang"
import customRewardImage from "@irati-web/reward/src/images/customReward.png"
import StockType from "@irati/stock/enums/StockType"

import CopyButton from "./CopyButton"
import PopUpHeader from "./PopUpHeader"
import ValueLabel from "./ValueLabel"
import Code from "./Code"

import {StyledModal, CustomCreditInstructions} from "./styled"

interface Props extends InjectIntl {
  show: boolean,
  onHide(): void,
  redemption?: RewardRedemption
}

class MyRewardPopup extends PureComponent<Props> {
  render() {
    const {show, onHide, redemption, formatMessage} = this.props
    if (!redemption) return null
    const {rewardOrder, custom} = redemption
    const {reward, product, createdBy} = rewardOrder
    const rewardStockExists = reward && redemption.stock && product

    return (
      <StyledModal show={show} onHide={onHide}>
        {rewardStockExists && (
          <PopUpHeader
            title={reward.header}
            subtitle={product.name}
            thumbnailImage={reward.thumbnailImage}
            instructions={reward.redemptionInstructions}
            termsAndConditions={reward.termsAndConditions}
            message={rewardOrder.message} />
        )}
        {custom && <PopUpHeader title={custom} thumbnailImage={customRewardImage} message={rewardOrder.message} />}
        {reward && reward.isCredit && (
          <PopUpHeader title={reward.header} subtitle={product.name} thumbnailImage={reward.thumbnailImage} message={rewardOrder.message} />
        )}

        {rewardStockExists && <Code redemption={redemption} />}

        {!rewardStockExists && custom && (
          <CustomCreditInstructions>
            <FormattedMessage
              id="recognition.account.rewards.customInstructions"
              values={{firstName: createdBy.firstname, lastName: createdBy.lastname}} />
          </CustomCreditInstructions>
        )}

        {reward && reward.isCredit && (
          <CustomCreditInstructions>
            <FormattedMessage id="recognition.account.rewards.creditInstructions" />
          </CustomCreditInstructions>
        )}

        {rewardStockExists && redemption.stock.expiry && (
          <ValueLabel
            date={<FormattedDate year="numeric" month="short" day="2-digit" value={redemption.stock.expiry} />}
            label={formatMessage({id: "recognition.account.rewards.expiryDate"})} />
        )}

        {rewardStockExists && redemption.stock.pin && (
          <ValueLabel value={redemption.stock.pin} label={formatMessage({id: "recognition.account.rewards.pin"})} />
        )}

        {rewardStockExists && redemption.stock.type === StockType.TEXT && (
          <CopyButton text={formatMessage({id: "recognition.account.rewards.copyCode"})} redemptionCode={redemption.stock.code} />
        )}
      </StyledModal>
    )
  }
}
export default injectIntl(MyRewardPopup)
